<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Personel</label>
            <v-select-list disabled v-model="employee" label="FullName" placeholder="Personel" :options="employees"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">İzin Türü</label>
            <v-select-list disabled v-model="type" label="Name" placeholder="İzin Türü" :options="types"/>
        </div>
        <div class="col-12 mb-1" v-if="$safe(type,'IsDocumentRequired')">
            <label class="form-label">Belge</label>
            <v-file-uploader v-model="value" :accept="['pdf','png','jpeg','jpeg']" value-parameter="Document"></v-file-uploader>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Talep Tarihi</label>
            <flat-pickr disabled v-model="value.RequestDate" class="form-control" :config="{altInput:true, altFormat:'d.m.Y',dateFormat: 'Y-m-d', locale:'tr'}" placeholder="Talep Tarihi"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Başlangıç Tarihi</label>
            <flat-pickr disabled v-model="value.StartDateTime" class="form-control" :config="{enableTime:true,altInput:true, altFormat:'d.m.Y H:i',dateFormat: 'Y-m-dTH:i', locale:'tr'}" placeholder="Başlangıç Tarihi"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Bitiş Tarihi</label>
            <flat-pickr disabled v-model="value.EndDateTime" class="form-control" :config="{enableTime:true,altInput:true, altFormat:'d.m.Y H:i',dateFormat: 'Y-m-dTH:i', locale:'tr'}" placeholder="Bitiş Tarihi"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Açıklama</label>
            <textarea disabled v-model="value.Description" placeholder="Açıklama" class="form-control resize-none"></textarea>
        </div>
        <div class="col-12">
            <label class="form-label">Durum</label>
            <select disabled class="form-control" v-model="value.Approved">
                <option v-for="(item,index) in statutes" :key="index" :value="item.value">{{item.text}}</option>
            </select>
        </div>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/l10n/tr.js' 
import EmployeeOperationsApi from '@/api/employee-operations'
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
export default {
    components:{
        flatPickr,
        VFileUploader
    },
    props:{
        value:Object,
    },
    data(){
        return{
            employees:[],
            statutes:[
                {text:"Beklemede",value:null},
                {text:"Onaylandı",value:true},
                {text:"Reddedildi",value:false},
            ],
            types:[]
        }
    },
    mounted(){
        this.getEmployees()
        this.getTypes()
    },
    methods:{
        getEmployees(){
            EmployeeOperationsApi.Employee.List().then(res=>{
                this.employees = res.data.Data
            })
        },
        getTypes(){
            EmployeeOperationsApi.ExcuseType.List().then(res=>{
                this.types = res.data.Data
            })
        }
    },
    computed:{
        employee:{
            get:function(){
                return this.employees.find(b=>b.Id==this.value.EmployeeId)
            },
            set:function(value){
                this.value.EmployeeId = value?.Id || null
            }
        },
        type:{
            get:function(){
                return this.types.find(b=>b.Id==this.value.ExcuseTypeId)
            },
            set:function(value){
                this.value.ExcuseTypeId = value?.Id || null
            }
        }
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>